const MultiGeocoder = require('multi-geocoder')

function onLoad(ymaps) {

    const myMap = new ymaps.Map("mapBlock", {
        // The map center coordinates.
        // Default order: “latitude, longitude”.
        // To not manually determine the map center coordinates,
        // use the Coordinate detection tool.
        // center: [lon, lat],
        // Zoom level. Acceptable values:
        // from 0 (the entire world) to 19.
        zoom: 12,
        // controls: [], // hide all controls
    });

    let geocoder = new MultiGeocoder({provider: 'yandex', coordorder: 'latlong'})
    let provider = geocoder.getProvider();

    provider.getText = function (point) {
        return point.address;
    };

    console.log('MAP LOADED')
    let suggestView = new ymaps.SuggestView('profile_addressStreet', {results: 5});
    suggestView.events.add('select', e => {
        let name = e.get('item').value
        geocoder.geocode([name])
            .then(function (res) {
                console.log('res', res);
            });
    })
}
